<template>
  <div v-if="proposalData.dadosCliente" class="wrapperPage pt-8">
    <div class="container flex flex-row items-center justify-between">
      <div class="logo ml-4 w-full">
        <img
          class="img-logo"
          src="../../assets/images/logo/logo-bpseguradora.svg"
        />
      </div>
      <div class="w-full flex flex-col p-1 text-sm">
        <h3 class="flex justify-center">
          {{ contractTitle }}
        </h3>
        <h6 v-if="isQuotation" class="flex justify-center">
          Apólice
          {{ formatPolicyNumber(previousPolicy) }}
        </h6>
      </div>
      <div class="w-full flex flex-col p-1 text-sm items-end">
        <img
          v-if="proposalData.regionalLogo"
          class="img-logo"
          :src="proposalData.regionalLogo"
        />
        <h3 v-if="!proposalData.regionalLogo" class="text-right">
          {{ proposalData.regional }}
        </h3>
      </div>
    </div>

    <div class="container justify-center">
      <EndorsementContractQuotationProposalData
        v-if="!isPolicy"
        :isQuotation="isQuotation"
        :isProposal="isProposal"
        :operationType="operationType"
        :proposalData="proposalData"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractPolicyData
        :isPolicy="isPolicy"
        :operationType="operationType"
        :previousPolicy="previousPolicy"
        :quotationData="quotationData"
        :proposalData="proposalData"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractBroker
        :broker="quotationData.broker"
        :proposalData="proposalData"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractInsured
        :isQuotation="isQuotation"
        :proposalData="proposalData"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractInsuredAddress
        :proposalData="proposalData"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractBonus
        :proposalData="proposalData"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractDriver
        :proposalData="proposalData"
        :quotationData="quotationData"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractOvernightAddress
        :quotationData="quotationData"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractVehicle
        :quotationData="quotationData"
        :customSectionsMsgs="customSectionsMsgs"
        :isQuotation="isQuotation"
      />

      <EndorsementContractIncreases
        :proposalData="proposalData"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractProducts
        :isEndorsementWithCalculation="isEndorsementWithCalculation"
        :selectedCoverage="selectedCoverage"
        :prizeData="prizeData"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractServices
        :quotationData="quotationData"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractGlassFranchise
        :quotationData="quotationData"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractPayment
        :isQuotation="isQuotation"
        :isPolicy="isPolicy"
        :quotationData="quotationData"
        :operationType="operationType"
        :operationTypeConfig="operationTypeConfig"
        :endorsementData="endorsementData"
        :proposalData="proposalData"
        :prizeData="prizeData"
        :previousPolicy="previousPolicy"
        :refundCompensationData="refundCompensationData"
        :isLoadingRefundCompensation="isLoadingRefundCompensation"
        :refundCompensationError="refundCompensationError"
        :refundBankOptions="refundBankOptions"
        :customSectionsMsgs="customSectionsMsgs"
        :refundMethodOptions="refundMethodOptions"
      />

      <EndorsementContractGeneralProvisions
        :isQuotation="isQuotation"
        :customSectionsMsgs="customSectionsMsgs"
      />

      <EndorsementContractSignatures
        v-if="isPolicy || isProposal"
        :isPolicy="isPolicy"
        :isQuotation="isQuotation"
        :contractText="contractText"
        :proposalData="proposalData"
        :previousPolicy="previousPolicy"
        :quotationData="quotationData"
        :customSectionsMsgs="customSectionsMsgs"
      />
    </div>
  </div>
</template>

<script>
import EndorsementContractBonus from '../../components/contracts/sections/EndorsementContractBonus.vue';
import EndorsementContractBroker from '../../components/contracts/sections/EndorsementContractBroker.vue';
import EndorsementContractDriver from '../../components/contracts/sections/EndorsementContractDriver.vue';
import EndorsementContractGeneralProvisions from '../../components/contracts/sections/EndorsementContractGeneralProvisions.vue';
import EndorsementContractGlassFranchise from '../../components/contracts/sections/EndorsementContractGlassFranchise.vue';
import EndorsementContractIncreases from '../../components/contracts/sections/EndorsementContractIncreases.vue';
import EndorsementContractInsured from '../../components/contracts/sections/EndorsementContractInsured.vue';
import EndorsementContractInsuredAddress from '../../components/contracts/sections/EndorsementContractInsuredAddress.vue';
import EndorsementContractOvernightAddress from '../../components/contracts/sections/EndorsementContractOvernightAddress.vue';
import EndorsementContractPayment from '../../components/contracts/sections/EndorsementContractPayment.vue';
import EndorsementContractPolicyData from '../../components/contracts/sections/EndorsementContractPolicyData.vue';
import EndorsementContractProducts from '../../components/contracts/sections/EndorsementContractProducts.vue';
import EndorsementContractServices from '../../components/contracts/sections/EndorsementContractServices.vue';
import EndorsementContractVehicle from '../../components/contracts/sections/EndorsementContractVehicle.vue';
import locale from '../../locale.js';
import autoApi from '../../services/auto.api';
import {
  getCustomSectionMsgs,
  hasInsuranceCompany,
  somaValorTotalValoresAvista,
} from '../../services/contract.js';
import { calcularFranquia } from '../../services/cotacao.js';
import endorsementApi from '../../services/endorsement.api';
import service from '../../services/index.js';
import pdfApi from '../../services/pdf.api.js';
import {
  PDF_DOCUMENT_TYPES,
  PAYMENT_METHODS,
  PRODUCTS_GROUPING,
} from '../../utils/constants.js';
import functions from '../../utils/functions.js';
import notify from '../../utils/notify.js';
import EndorsementContractQuotationProposalData from './sections/EndorsementContractQuotationProposalData.vue';
import EndorsementContractSignatures from './sections/EndorsementContractSignatures.vue';
import {
  getEmptyRefundCompensationData,
  isCancellationOperationType,
  normalizeRefundCompensationData,
} from '../../views/pages/Endorsement/utils/refundCompensation';
const { TIPO_APOLICE } = require('../../../common/constant/tipo_apolice.js');

export default {
  name: 'EndorsementContract',
  props: {
    isQuotation: {
      type: Boolean,
      required: false,
      default: false,
    },
    isProposal: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPolicy: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      comprehensiveLabel: 'Casco compreensivo',
      PRODUCTS_GROUPING,
      hasInsuranceCompany,
      somaValorTotalValoresAvista,
      customSectionsMsgs: {},
      TIPO_APOLICE,
      proposalData: {},
      quotationData: {},
      contractText: '',
      functions,
      controller: 'auto',
      action: 'quotations',
      operationType: null,
      operationTypeConfig: null,
      endorsementData: null,
      previousPolicy: null,
      refundCompensationData: getEmptyRefundCompensationData(),
      isLoadingRefundCompensation: false,
      refundCompensationError: null,
      refundBankOptions: [],
      refundMethodOptions: [],
    };
  },
  computed: {
    documentType() {
      if (this.isQuotation) {
        return PDF_DOCUMENT_TYPES.ENDORSEMENT_QUOTATION;
      }
      if (this.isProposal) {
        return PDF_DOCUMENT_TYPES.ENDORSEMENT_PROPOSAL;
      }
      if (this.isPolicy) {
        return PDF_DOCUMENT_TYPES.ENDORSEMENT_POLICY;
      }
      return null;
    },
    contractTitle() {
      if (this.isQuotation) {
        return 'Cotação de Endosso';
      }
      if (this.isProposal) {
        return 'Proposta de Endosso';
      }
      return 'Endosso';
    },
    prizeData() {
      return this.endorsementData && this.endorsementData.prize
        ? this.endorsementData.prize
        : {
            tariff_prize: 0,
            interest: 0,
            iof_value: 0,
            prize: 0,
          };
    },
    isEndorsementWithCalculation() {
      return Boolean(
        this.endorsementData &&
          this.endorsementData.prize &&
          Array.isArray(this.endorsementData.prize.details) &&
          this.endorsementData.prize.details.length > 0,
      );
    },
    selectedCoverage() {
      const coverageContracted =
        this.quotationData && this.quotationData.coverage_contracted;
      let allCoverages;

      if (this.isEndorsementWithCalculation) {
        allCoverages = this.endorsementData.prize;
      } else {
        allCoverages = this.quotationData.all_coverages;
      }

      return functions.getEndorsementContractedProductsWithDetails(
        coverageContracted,
        allCoverages,
        false,
      );
    },
    refundCompensationPolicyId() {
      return (
        (this.endorsementData && this.endorsementData.previousPolicyId) ||
        (this.previousPolicy && this.previousPolicy.id) ||
        (this.quotationData && this.quotationData.id) ||
        this.proposalData.idApolice ||
        this.proposalData.apolice_id ||
        null
      );
    },
    endorsementOperationTypeId() {
      return (
        (this.endorsementData && this.endorsementData.operationTypeId) ||
        (this.quotationData &&
          this.quotationData.endorsement &&
          this.quotationData.endorsement.operationTypeId) ||
        null
      );
    },
    isBilletPreviousPolicyPayment() {
      const paymentMethod =
        this.previousPolicy && this.previousPolicy.paymentMethod;

      return Boolean(
        (this.previousPolicy &&
          this.previousPolicy.paymentTypeId === PAYMENT_METHODS.BILLET.id) ||
          (paymentMethod &&
            paymentMethod.toLowerCase() ===
              PAYMENT_METHODS.BILLET.name.toLowerCase()),
      );
    },
    shouldHandleRefundCompensation() {
      return Boolean(
        this.prizeData.prize < 0 &&
          (isCancellationOperationType(this.operationTypeConfig) ||
            this.isBilletPreviousPolicyPayment),
      );
    },
  },
  methods: {
    formatPolicyNumber(policy) {
      if (!policy || policy.policyNumber == null) {
        return '';
      }

      return this.functions.formatEmitterNumber(
        policy.policyNumber,
        this.proposalData.idTipoApolice,
        'POLICY',
      );
    },
    async fetchQuotationData() {
      if (this.$route.query.interno) {
        this.isInterno = true;
      } else {
        this.isInterno = false;
      }
      this.$vs.loading();
      let objSend = {};
      objSend.chave = this.$route.params.chave;
      objSend.idProposta = this.$route.params.idProposta;

      return service
        .post(
          'CotacaoAberta',
          'buscaDadosVida?contractPdfLog=quotation-auto',
          objSend,
        )
        .then(async (res) => {
          try {
            const data = await pdfApi.getQuotationPDFData(
              res.data[0].idProposta,
            );

            this.quotationData = data;
            this.proposalData = res.data[0];
            this.proposalData = calcularFranquia(this.proposalData);

            let contractText = res.data[0].termos.find(
              (x) => x.tipoContrato == 'Termo de Ativação',
            );
            if (this.proposalData.tipoProposta == 'Reativação') {
              contractText = res.data[0].termos.find(
                (x) => x.tipoContrato == 'Termo de Reativação',
              );
            }
            this.contractText = contractText && contractText.modeloContrato;

            this.customSectionsMsgs = getCustomSectionMsgs(
              res.data[0].termos,
              this.documentType,
            );
            this.$vs.loading.close();
          } catch (error) {
            return notify.notifyFail(
              this.$vs,
              'Ocorreu um erro, por favor tente novamente',
            );
          }
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    isIndividualPerson(cpf) {
      return cpf.length <= 14 ? true : false;
    },
    async loadRefundBankOptions() {
      try {
        const banks = [];
        await functions.buscaDadosSelects(
          'domBancos',
          banks,
          'LongName',
          'idBanco',
        );
        this.refundBankOptions = banks;
      } catch (error) {
        console.error(error);
      }
    },
    async getRefundCompensationData() {
      if (
        !this.refundCompensationPolicyId ||
        !this.shouldHandleRefundCompensation ||
        isCancellationOperationType(this.operationTypeConfig)
      ) {
        this.refundCompensationData = getEmptyRefundCompensationData();
        this.refundCompensationError = null;
        this.isLoadingRefundCompensation = false;
        return;
      }

      this.isLoadingRefundCompensation = true;
      this.refundCompensationError = null;

      try {
        const response = await autoApi.getNegativeEndorsementInstallments(
          this.refundCompensationPolicyId,
        );
        this.refundCompensationData = normalizeRefundCompensationData(response);
      } catch (error) {
        console.error(error);
        this.refundCompensationData = getEmptyRefundCompensationData();
        this.refundCompensationError =
          'Não foi possível buscar os dados de compensação da restituição.';
      } finally {
        this.isLoadingRefundCompensation = false;
      }
    },
    async getOperationTypeConfig() {
      if (!this.endorsementOperationTypeId) {
        this.operationTypeConfig = null;
        return;
      }

      try {
        const operationTypes =
          await endorsementApi.getAllOperationTypeConfigs();
        this.operationTypeConfig = Array.isArray(operationTypes)
          ? operationTypes.find(
              (operationType) =>
                operationType.id === this.endorsementOperationTypeId,
            ) || null
          : null;
      } catch (error) {
        console.error(error);
        this.operationTypeConfig = null;
      }
    },
    async getPdfData() {
      return endorsementApi
        .getQuotationContractData(this.$route.params.chave)
        .then(async (res) => {
          this.previousPolicy = res.previousPolicy;
          this.operationType = res.operationType;
          this.endorsementData = res.endorsement
            ? { ...res.endorsement, refundComposition: res.refundComposition }
            : res.endorsement;
          await this.getOperationTypeConfig();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getRefundMethodsOptions() {
      endorsementApi
        .getRefundMethods()
        .then((res) => {
          this.refundMethodOptions = res.map((method) => ({
            name: method.name,
            id: method.id,
          }));
        })
        .catch((error) => {
          console.error('Erro ao buscar formas de restituição:', error);
        });
    },
  },
  async created() {
    await this.getPdfData();
    await Promise.all([
      this.loadRefundBankOptions(),
      this.fetchQuotationData(),
    ]);
    await this.getRefundCompensationData();
    await this.getRefundMethodsOptions();
    this.$validator.localize('ptBr', locale);
  },
  components: {
    EndorsementContractBroker,
    EndorsementContractBonus,
    EndorsementContractOvernightAddress,
    EndorsementContractIncreases,
    EndorsementContractGeneralProvisions,
    EndorsementContractProducts,
    EndorsementContractGlassFranchise,
    EndorsementContractServices,
    EndorsementContractVehicle,
    EndorsementContractInsuredAddress,
    EndorsementContractInsured,
    EndorsementContractDriver,
    EndorsementContractPayment,
    EndorsementContractPolicyData,
    EndorsementContractQuotationProposalData,
    EndorsementContractSignatures,
  },
};
</script>

<style>
@import url('https://fonts.cdnfonts.com/css/gotham');

.wrapperPage {
  font-family: 'regular', 'Gotham', sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
}

.img-logo {
  width: 200px;
  height: 100px;
}

table {
  width: 100%;
  table-layout: auto;
}

tr:nth-child(odd) {
  background-color: #edf4fb;
}

.A3 .sheet {
  width: 297mm;
  height: 419mm;
}
.A3.landscape .sheet {
  width: 420mm;
  height: 297mm;
}
.A4 .sheet {
  width: 100%;
  height: 297mm;
}
.A4.landscape .sheet {
  width: 297mm;
  height: 210mm;
}
.A5 .sheet {
  width: 148mm;
  height: 210mm;
}
.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}

/** For screen preview **/
@media screen {
  body {
    background: #e0e0e0;
    display: flex;
    justify-content: center;
  }
}

@page {
  size: A4;
  margin: 0;
}

@page {
  @bottom-center {
    content: 'Página ' counter(page) ' de ' counter(pages);
  }
}

@media print {
  .A3.landscape {
    width: 420mm;
  }
  .A3,
  .A4.landscape {
    width: 297mm;
  }
  .A4,
  .A5.landscape {
    width: 210mm;
  }
  .A5 {
    width: 148mm;
  }
}

@media print {
  .non-printer {
    display: none;
  }
  .vue-back-to-top {
    display: none !important;
  }
  .pdf {
    width: auto;
    height: 200mm;
  }
  .folha {
    height: 297mm;
    padding: 0 0 0 0;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
  #content-area {
    margin-left: 0;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0;
  }
  .vs-content-sidebar,
  .router-header,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
  .pagebreak-before {
    break-before: always;
    page-break-before: always;
  }
  .pagebreak-after {
    break-after: always;
    page-break-after: always;
  }
  .pagebreak-inside-avoid {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .vx-card__body {
    padding: 0 !important;
    margin: 0 !important;
  }
  .img-logo {
    width: 100px;
    height: 50px;
  }
  .wrapperPage {
    padding-top: 1em !important;
    margin: 0;
  }
  .cabecalho-impressao {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  @page {
    size: A4;
    margin: 0;
    padding: 0;
  }
  .container {
    padding: 8px;
    margin: 0;
    width: 100%;
    max-width: 100%;
  }
}
</style>
